if (!customElements.get('ff-sticky-atc')) {
  customElements.define(
    'ff-sticky-atc',
    class FfStickyAtc extends HTMLElement {
      connectedCallback() {
        const section = this.closest('.shopify-section');
        this.target = section?.querySelector('ff-buy-buttons:not(ff-sticky-atc ff-buy-buttons)');
        if (!this.target) return;

        this.header = document.querySelector('.ff-header-wrapper');
        this.footer = document.querySelector('.shopify-section-group-footer-group .ff-footer-wrapper');
        this.ticking = false;

        this.handleScroll = () => {
          if (!this.ticking) {
            requestAnimationFrame(() => {
              this.update();
              this.ticking = false;
            });
            this.ticking = true;
          }
        };

        window.addEventListener('scroll', this.handleScroll, { passive: true });
        this.update();
      }

      getHeaderOffset() {
        if (!this.header || !this.header.classList.contains('ff-sticky')) return 0;
        return Math.max(0, this.header.getBoundingClientRect().bottom);
      }

      update() {
        if (!this.footer) {
          this.footer = document.querySelector('.shopify-section-group-footer-group .ff-footer-wrapper');
        }

        const rect = this.target.getBoundingClientRect();
        const isOutOfView = rect.bottom < this.getHeaderOffset();

        const reachedFooter = this.footer && this.footer.getBoundingClientRect().top <= window.innerHeight;

        this.classList.toggle('ff-sticky-atc--visible', isOutOfView && !reachedFooter);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.handleScroll);
      }
    }
  );
}
